import Link from "next/link";
import { DashboardModelSummaryCard } from "@/components/dashboard.model-card";
import { RADIUM_SHOWCASE_MODELS } from "@/lib/models-showcase";

/** Compact marketing copy for dashboard cards (Figma), keyed by showcase model id. */
const DASHBOARD_MODEL_BLURBS: Record<string, { label: string; description: string }> = {
  "hal-1.0": {
    label: "Maximum Capability",
    description: "Designed for complex reasoning, agent workflows, and software tasks.",
  },
  "clarke-1.0": {
    label: "Balanced Performance",
    description: "Strong performance with the best balance of speed and cost.",
  },
  "tycho-1.0": {
    label: "High-Efficiency Scale",
    description:
      "Ultra-efficient inference for high-throughput applications, early development, and lightweight agents.",
  },
};

export const DashboardModels = () => (
  <section aria-labelledby="dashboard-models-heading" className="space-y-4">
    <div className="flex items-center justify-between gap-4">
      <h2 id="dashboard-models-heading" className="text-lg font-semibold tracking-tight">
        Models
      </h2>
      <Link href="/models" className="text-sm font-medium underline underline-offset-4 hover:text-foreground/70">
        Compare models
      </Link>
    </div>
    <div className="grid gap-4 md:grid-cols-3">
      {RADIUM_SHOWCASE_MODELS.map((model) => {
        const copy = DASHBOARD_MODEL_BLURBS[model.id] ?? {
          label: model.tagline,
          description: model.description,
        };
        return (
          <DashboardModelSummaryCard
            key={model.id}
            name={model.marketingName}
            label={copy.label}
            description={copy.description}
          />
        );
      })}
    </div>
  </section>
);
